// extracted by mini-css-extract-plugin
export default {"container":"Bloc_container__vYpDA","box":"Bloc_box__J9lMP","innerContainer":"Bloc_innerContainer__ZFNQg","innerBox1":"Bloc_innerBox1__MyCyK","innerBox2":"Bloc_innerBox2__aYKrG"};